var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        {
          staticClass: "pa-2",
          class: { "no-drop": _vm.isAdmin || _vm.isSeaOperator },
          attrs: { width: "100%" },
        },
        [
          _vm.isAdmin || _vm.isSeaOperator
            ? _c(
                "div",
                { staticClass: "d-flex justify-end mb-2" },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      attrs: {
                                        small: "",
                                        outlined: "",
                                        color: "primary",
                                      },
                                      on: { click: _vm.openMultiUploadDialog },
                                    },
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("label.uploadDocument")) +
                                        " "
                                    ),
                                    _c("v-icon", [_vm._v("mdi-upload")]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3402152042
                      ),
                    },
                    [
                      _c("span", { staticClass: "text-caption" }, [
                        _vm._v(_vm._s(_vm.$t("label.uploadDocument"))),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-expansion-panels",
            {
              staticClass: "folders-panels",
              attrs: { multiple: "", flat: "" },
              model: {
                value: _vm.openPanels,
                callback: function ($$v) {
                  _vm.openPanels = $$v
                },
                expression: "openPanels",
              },
            },
            _vm._l(_vm.visibleFolders, function (folder) {
              return _c(
                "v-expansion-panel",
                {
                  key: folder.party,
                  class: {
                    "panel-drag-over": _vm.draggingParty === folder.party,
                  },
                },
                [
                  _c(
                    "v-expansion-panel-header",
                    {
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                          !_vm.isAdmin &&
                            !_vm.isSeaOperator &&
                            (_vm.draggingParty = folder.party)
                        },
                        dragenter: function ($event) {
                          $event.preventDefault()
                          !_vm.isAdmin &&
                            !_vm.isSeaOperator &&
                            (_vm.draggingParty = folder.party)
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          !_vm.isAdmin &&
                            !_vm.isSeaOperator &&
                            (_vm.draggingParty = null)
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          !_vm.isAdmin &&
                            !_vm.isSeaOperator &&
                            _vm.onDrop($event, folder.party)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center justify-space-between",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "primary" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        folder.files.length
                                          ? "mdi-folder"
                                          : "mdi-folder-outline"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-weight-medium" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(`label.party.${folder.party}`)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    "x-small": "",
                                    color: "grey lighten-3",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(folder.files.length) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              !_vm.isAdmin && !_vm.isSeaOperator
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.selectFile(
                                                            folder.party
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("mdi-upload"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-caption" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("label.uploadDocument")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.selected[folder.party]?.length
                                ? _c("ButtonConfirmDialog", {
                                    attrs: {
                                      icon: "mdi-delete",
                                      color: "error",
                                      body: _vm.$t("message.confirmDeletion"),
                                      title: _vm.$t("label.confirmDelete"),
                                    },
                                    on: {
                                      submit: function ($event) {
                                        return _vm.deleteSelected(folder.party)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c("v-data-table", {
                        staticClass: "scrollable",
                        attrs: {
                          headers: _vm.headers,
                          items: folder.files,
                          loading: folder.loading,
                          "item-key": "id",
                          "items-per-page": 1000,
                          "hide-default-footer": "",
                          "show-select": "",
                          "fixed-header": "",
                          dense: "",
                          height: "100%",
                          "no-data-text": "No data available",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item.fileName",
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { color: "primary", small: "" },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.getIcon(item)) + " "
                                      ),
                                    ]
                                  ),
                                  _c("span", { staticClass: "text-body-2" }, [
                                    _vm._v(_vm._s(item.fileName)),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.createDatetime",
                              fn: function ({ item }) {
                                return [
                                  _c("span", { staticClass: "text-body-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(item.createDatetime)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.actions",
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-end align-center",
                                    },
                                    [
                                      _vm.isAdmin || _vm.isSeaOperator
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                                color:
                                                                  "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openCopyDialog(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  "x-small": "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-content-copy"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text-caption" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label.copyToFolder"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("PraticaDocumentActions", {
                                        attrs: {
                                          document: item,
                                          "can-delete": _vm.canDelete(item),
                                        },
                                        on: {
                                          "delete-file": (id) =>
                                            _vm.deleteFile(id, folder.party),
                                          "download-file": _vm.downloadDocument,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.selected[folder.party],
                          callback: function ($$v) {
                            _vm.$set(_vm.selected, folder.party, $$v)
                          },
                          expression: "selected[folder.party]",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("input", {
        ref: "fileUpload",
        attrs: { type: "file", hidden: "" },
        on: { change: ($event) => _vm.uploadFile($event?.target?.files?.[0]) },
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.multiUploadDialog,
            callback: function ($$v) {
              _vm.multiUploadDialog = $$v
            },
            expression: "multiUploadDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text text-caption py-2 px-3" },
                [_vm._v(" " + _vm._s(_vm.$t("label.uploadDocument")) + " ")]
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-4" },
                [
                  _c("p", { staticClass: "mb-3 text-body-2" }, [
                    _vm._v(_vm._s(_vm.$t("message.selectFoldersForUpload"))),
                  ]),
                  _vm._l(_vm.PARTIES, function (party) {
                    return _c("v-checkbox", {
                      key: party,
                      attrs: {
                        label: _vm.$t(`label.party.${party}`),
                        value: party,
                        dense: "",
                        "hide-details": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("span", { staticClass: "text-body-2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t(`label.party.${party}`))
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.multiUploadParties,
                        callback: function ($$v) {
                          _vm.multiUploadParties = $$v
                        },
                        expression: "multiUploadParties",
                      },
                    })
                  }),
                ],
                2
              ),
              _c(
                "v-card-actions",
                { staticClass: "justify-start px-2" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      attrs: {
                        small: "",
                        disabled: !_vm.multiUploadParties.length,
                      },
                      on: { click: _vm.confirmMultiUpload },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("label.confirm")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "error",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          _vm.multiUploadDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("label.close")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.copyDialog,
            callback: function ($$v) {
              _vm.copyDialog = $$v
            },
            expression: "copyDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text text-caption py-2 px-3" },
                [_vm._v(" " + _vm._s(_vm.$t("label.copyToFolder")) + " ")]
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-4" },
                [
                  _c("p", { staticClass: "mb-3 text-body-2" }, [
                    _vm._v(_vm._s(_vm.$t("message.selectFoldersToCopy"))),
                  ]),
                  _vm._l(_vm.availableCopyTargets, function (party) {
                    return _c("v-checkbox", {
                      key: party,
                      staticClass: "mt-1",
                      attrs: { value: party, dense: "", "hide-details": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("span", { staticClass: "text-body-2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t(`label.party.${party}`))
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.copyTargetParties,
                        callback: function ($$v) {
                          _vm.copyTargetParties = $$v
                        },
                        expression: "copyTargetParties",
                      },
                    })
                  }),
                ],
                2
              ),
              _c(
                "v-card-actions",
                { staticClass: "justify-start px-2" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      attrs: {
                        small: "",
                        disabled: !_vm.copyTargetParties.length,
                      },
                      on: { click: _vm.confirmCopy },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("label.confirm")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "error",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          _vm.copyDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("label.close")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }